import { createReducer } from "../../util/reducerUtil";
import {
    CREATE_TEST_TREE,
    UPDATE_TEST_TREE,
    FETCH_TEST_TREE
} from "./userTestTreeConstants";

const initialState = {
    testTree: {}
};

export const createTestTree = (state, payload) => {
    return { ...state, testTree: payload };
};

export const updateTestTree = (state, payload) => {
    return { ...state, testTree: payload };
};

export const fetchTestTree = (state, payload) => {
    return { ...state, testTree: payload };
};

export default createReducer(initialState, {
    [CREATE_TEST_TREE]: createTestTree,
    [UPDATE_TEST_TREE]: updateTestTree,
    [FETCH_TEST_TREE]: fetchTestTree
});
